import { FC } from 'react';
import CrossIcon from '../../atoms/CrossIcon';
import SearchIcon from '../../atoms/SearchIcon';
import styles from './SearchInput.module.css';
import IconButton from '../IconButton';

type SearchInputProps = {
  value: string;
  isDisabled?: boolean;
  placeHolder?: string;
  onChange: (value: string) => void;
  onReset: () => void;
};

const SearchInput: FC<SearchInputProps> = ({
  value,
  isDisabled = false,
  placeHolder = 'PlaceHolder',
  onChange,
  onReset,
}) => {
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = event.target.value;
    onChange(searchText);
  };

  const handleCrossIconClick = () => {
    onReset();
  };
  return (
    <div tabIndex={0} className={styles['search-input']}>
      <SearchIcon />
      <input
        type='text'
        value={value}
        placeholder={placeHolder}
        disabled={isDisabled}
        onChange={handleSearchChange}
        className={styles['search-input__input']}
      />
      {value && (
        <IconButton
          onClick={handleCrossIconClick}
          ariaLabel='reset the search bar'
        >
          <CrossIcon />
        </IconButton>
      )}
    </div>
  );
};

SearchInput.displayName = 'SearchInput';

export default SearchInput;
